declare const _UC_CDN_DOMAIN_: string;

export const CDN_BASE_URL = `https://${(_UC_CDN_DOMAIN_ || "").replace(/\/$/, "")}`;

export function createCdnThumbnailUrl(productImage?: string, size?: number) {
    if (!productImage) return "";

    if (!size) size = 256;

    const prefixedPath = `thumbnails/36_${size}/${productImage}.png`;
    const cleanPath = prefixedPath.replace(/^\/+/, "");

    return `${CDN_BASE_URL}/${cleanPath}`;
}